/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { BiomarkerResponseDto } from './BiomarkerResponseDto';
import {
    BiomarkerResponseDtoFromJSON,
    BiomarkerResponseDtoFromJSONTyped,
    BiomarkerResponseDtoToJSON,
    BiomarkerResponseDtoToJSONTyped,
} from './BiomarkerResponseDto';

/**
 * 
 * @export
 * @interface BiomarkersListResponseDto
 */
export interface BiomarkersListResponseDto {
    /**
     * List of biomarkers
     * @type {Array<BiomarkerResponseDto>}
     * @memberof BiomarkersListResponseDto
     */
    data: Array<BiomarkerResponseDto>;
    /**
     * Pagination metadata
     * @type {PaginationDto}
     * @memberof BiomarkersListResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the BiomarkersListResponseDto interface.
 */
export function instanceOfBiomarkersListResponseDto(value: object): value is BiomarkersListResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function BiomarkersListResponseDtoFromJSON(json: any): BiomarkersListResponseDto {
    return BiomarkersListResponseDtoFromJSONTyped(json, false);
}

export function BiomarkersListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BiomarkersListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BiomarkerResponseDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function BiomarkersListResponseDtoToJSON(json: any): BiomarkersListResponseDto {
    return BiomarkersListResponseDtoToJSONTyped(json, false);
}

export function BiomarkersListResponseDtoToJSONTyped(value?: BiomarkersListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BiomarkerResponseDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

